<template>
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
  >
    <path d="M0.423477 0.118496C0.57617 -0.0108545 0.79128 -0.0367025 0.97027 0.0527924L13.9703 6.55279C14.1396 6.63748 14.2466 6.81061 14.2466 7C14.2466 7.18939 14.1396 7.36252 13.9703 7.44721L0.97027 13.9472C0.79128 14.0367 0.57617 14.0109 0.423477 13.8815C0.270784 13.7522 0.209923 13.5442 0.268775 13.353L2.22353 7L0.268775 0.647048C0.209923 0.455781 0.270784 0.247847 0.423477 0.118496ZM3.11595 7.5L1.56819 12.5302L12.6286 7L1.56819 1.46979L3.11595 6.5H8.74665C9.02279 6.5 9.24665 6.72386 9.24665 7C9.24665 7.27614 9.02279 7.5 8.74665 7.5H3.11595Z" />
  </svg>
</template>
